import { Field, useFormikContext } from 'formik';
import { useEffect, useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useCheckoutState } from '../../../utils/checkoutState';
import getValidator from '../../../utils/getValidator';
import { mountScript } from '../../../utils/useScript';
import TextField from '../../formik/TextField';
import './style.scss';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    di?: { t: string; v: string; l: string };
  }
}

const baseTranslationPath = 'payment.paymentMethod.sepaDirectDebitForm';

const RatepayPayment = () => {
  const { checkoutState } = useCheckoutState();
  const [isConsentOpen, setConsentOpen] = useState(false);
  const { formatMessage } = useIntl();
  const {
    values: { paymentMethod },
  } = useFormikContext<{ paymentMethod: string }>();

  const { id, token } =
    checkoutState.orderState.payment?.selected?.[0].configuration?.initializationData?.deviceIdent ?? {};
  const previousToken = useRef();

  useEffect(() => {
    if (!token || token === previousToken.current) {
      return;
    }

    previousToken.current = token;
    window.di = { t: token, v: id, l: 'Checkout' };
    mountScript(`https://d.ratepay.com/${id}/di.js`);
    // eslint-disable-next-line consistent-return
    return () => {
      delete window.di;
    };
  }, [id, token, previousToken]);

  if (paymentMethod === 'ratepay_directdebit') {
    return (
      <div className="option__form">
        <div className="form">
          {/* <div className="form__row">
            <div className="form__field-container">
              <Field
                name="sepaDirectDebit.accountOwner"
                component={TextField}
                label={formatMessage({ id: baseTranslationPath + '.accountOwner' })}
                validate={getValidator({ required: true, minLength: 2, format: 'name' })}
                data-test-id="account-owner"
              />
            </div>
          </div> */}
          <div className="form__row">
            <div className="form__field-container">
              <Field
                name="sepaDirectDebit.iban"
                component={TextField}
                label={formatMessage({ id: baseTranslationPath + '.iban' })}
                validate={getValidator({ required: true, format: 'iban' })}
                data-test-id="iban"
              />
            </div>
          </div>
          <div className="form__row consent">
            <div className="consent__label" onClick={() => setConsentOpen(!isConsentOpen)}>
              {formatMessage({ id: `${baseTranslationPath}.consent.title.${!isConsentOpen ? 'isClosed' : 'isOpen'}` })}
            </div>
            {isConsentOpen && (
              <div className="consent__content">
                {formatMessage({ id: baseTranslationPath + '.consent.content' })}
                <br />
                <br />
                {formatMessage({ id: baseTranslationPath + '.consent.hint' })}
              </div>
            )}
          </div>
          <div className="form__row legal">
            RatePAY GmbH • Franklinstraße 28-29 • 10587 Berlin
            <br />
            Gläubiger-ID: DE39RPY00000568463
            <br />
            Mandatsreferenz: (wird nach Kaufabschluss übermittelt)
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default RatepayPayment;
